import HomeNavBar from "@/components/HomeNavBar/HomeNavBar.vue"
import AllGroups from "@/components/GetGroups/GroupsComponent.vue"
import GroupFeedCommentModal from "@/components/GroupFeedCommentModal/GroupFeedComment.vue"
import GroupFeed from "@/components/GroupFeed/GroupFeed.vue"
import StickyNav from "@/components/BottomNavbar/StickyNavbar.vue"
import SurveyView from "@/components/SurveysAndPolls/Survey.vue"
import Comments from '@/components/GroupComments/Comments.vue';
import Swal from 'sweetalert2';
import axios from "axios";
import { get_token, get_user_details } from "@/router";
import { client_domain } from "@/main.js";
import AllPortals from "@/components/GetPortals/PortalsComponent.vue"

const GLOBAL_URL = process.env.VUE_APP_BACKEND_API_URL;
export default {
  components: {
    HomeNavBar,
    SurveyView,
    AllGroups,
    StickyNav,
    GroupFeedCommentModal,
    GroupFeed,
    Comments,
    group_creator_id: null,
    isCreator: false,
    AllPortals,

  },

  created() {
    this.fetchGroupFeeds();
    this.fetchGroupMembers();
  },
  mounted() {
    this.token_exists = get_token();
    this.user_id = this.get_user_id();
    if (this.$route.params.group_id) {

      this.getGroupFeedLikes();
      this.fetchGroupMembers();
      this.fetchGroupFeeds();
    }

    if (client_domain.includes('chiefluthuli')) {
      this.school_domain = true
    }

    const editGroupFeedModal = $('#edit_feed_modal');

    editGroupFeedModal.on('show.bs.modal', () => {
      this.resetSelection();
    });
    $('#add_group_member_modal').on('shown.bs.modal', () => {
      this.$nextTick(() => this.init_DataTable('#addMembersTable'))
    })

    $('#add_group_member_modal').on('hidden.bs.modal', () => {
      this.destroy_dataTable('#addMembersTable')
    })

    $('#delete_group_member_modal').on('shown.bs.modal', () => {
      this.$nextTick(() => this.init_DataTable('#deleteMembersTable'))
    })

    $('#delete_group_member_modal').on('hidden.bs.modal', () => {
      this.destroy_dataTable('#deleteMembersTable')
    })
  },
  watch: {
    '$route.params.group_id'() {
      this.fetchGroupMembers();
      this.fetchGroupFeeds();
    },
  },
  computed: {
    areAllSelected() {
      const filteredIds = this.members.map(user => user.id);
      return filteredIds.every(id => this.selectedUserIds.includes(id)) && filteredIds.length > 0;
    },
    areAllForDeleteSelected() {
      const filteredIds = (this.group_members.filter(item => item.user.role.role !== 'admin')).map(user => user.user.id);
      return filteredIds.every(id => this.selectedUserIds.includes(id)) && filteredIds.length > 0;
    },
    filteredUsers() {
      let members = this.group_members.filter(user => user.id !== this.user_id);

      return members;
    },
    filteredMembers() {
      if (!this.group_members) return [];
      let members = this.group_members;
      return members;
    },

    // (Keep your existing areAllForDeleteSelected logic here)
  },
  data() {
    return ({
      activeTab: 'your_feed',
      group_members: [],
      token_exists: false,
      group_feed_id: null,
      user_id: null,
      selectedMembers: [],
      user_details: get_user_details(),
      group_creator_id: null,
      isCreator: false,
      comment_modal_visible: false,
      deleteMode: false,
      exitMode: false,
      group_feeds: [],
      feed_data: {},
      expandedFeeds: [],
      edit_feed_name: '',
      edit_feed_description: '',
      edit_feed_id: null,
      edit_files: {},
      errors: {
        edit_feed_name: '',
        editFileError: null,
        editAudioError: null,
        editFileName: null,
      },
      likedReports: JSON.parse(localStorage.getItem("likedReports") || "{}"),
      isRecording: false,
      audio_file: null,
      mediaRecorder: null,
      recordedChunks: [],
      audio_file_name: '',
      upload_media: null,
      editFileError: '',
      editAudioError: '',
      editFileName: '',
      members: [],
      group_surveys: [],
      isLoading: false,
      isSubmitting: false,
      selectedUserIds: [],
      group_can_comment: true,
      is_feed_loading: false,
      page: 1,
      page_size: 5,
      hasMore: false,
      preloadedReports: [],
      active_group_id: null,
      activeProfile: [],
      activeCommentReportId: null,
      searchQuery: "",
      showSuggestions: false,
      school_domain: true,
      commentText: '',
    });
  },
  methods: {
    init_DataTable(table_id) {
      if ($.fn.DataTable.isDataTable(table_id)) return

      $(table_id).DataTable({
        pageLength: 10,
        ordering: true,
        responsive: true,
        autoWidth: false,
        language: {
          search: "",
          lengthMenu: "Show _MENU_",
          info: "Showing _START_ to _END_ of _TOTAL_ members",
          paginate: {
            previous: "Prev",
            next: "Next"
          }
        },
        columnDefs: [
          { orderable: false, targets: -1 }
        ]
      })
    },

    destroy_dataTable(table_id) {
      if ($.fn.DataTable.isDataTable(table_id)) {
        $(table_id).DataTable().destroy()
      }
      // 🔥 reset add modal state
      this.selectedUserIds = [];
      this.members = [];

      // 🔥 reset delete modal state
      this.selectedDeleteUserIds = [];
      this.deleteMembers = [];
    },

    async submit_comment(report_id) {
      if (!this.token_exists) {
        this.$router.push('/sign_in_finale');
        return;
      }

      const comment_text = $("#comment_text_area").val();

      if (comment_text.trim() === "") {
        Swal.fire({
          icon: 'error',
          title: 'Please write a comment before submitting.',
          timer: 2000,
          showConfirmButton: false,
        });
        return;
      }

      const baseUrl = `${window.location.origin}${this.$route.path}?report_id=${report_id}`;
      this.commentText = "";
      $("#comment_text_area").val("");

      const request_data = {
        report_id,
        comment_text,
        base_url: baseUrl
      };

      const request_url = `${GLOBAL_URL}/group_management/add_feed_comment/`;

      $.ajax({
        url: request_url,
        method: 'POST',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: JSON.stringify(request_data),
        success: (response) => {
          if (response.status === "success") {
            const newComment = response.data.comment_data;

            // ✅ Find the report in parent state
            const reportIndex = this.group_feeds.findIndex(r => r.id === report_id);
            const report = this.group_feeds.at(reportIndex); // safer access

            if (report) {
              // ✅ Replace comments array so Vue notices the change
              report.comments = [newComment].concat(report.comments);

              // ✅ Increment total_comments
              report.total_comments = (report.total_comments || 0) + 1;

              // ✅ Replace parent reports array for top-level reactivity
              this.group_feeds = Array.from(this.group_feeds);
            }

            // Clear input
            this.commentText = "";
            $("#comment_text_area").val("");
          }
        },
        error: () => {
          Swal.fire({
            icon: 'error',
            title: 'Could not add comment',
            text: 'Please try again later.',
            timer: 3000,
            showConfirmButton: false,
            position: 'bottom-end',
            toast: true
          });
        },
        complete: () => {
          this.isSubmitting = false;
        }
      });
    },
    onActiveProfileLoaded(profile) {
      this.activeProfile = profile
    },

    reset_modal_data() {
      this.form = {};
    },

    handleAddComment({ report_id, newComment }) {
      const reportIndex = this.group_feeds.findIndex(r => r.id === report_id);
      const report = this.group_feeds.at(reportIndex); // ✅ safe accessor
      if (report) {
        report.comments = [newComment].concat(report.comments);
        this.group_feeds = Array.from(this.group_feeds); // ✅ reactivity trigger
      }
    },

    onCommentInput() {
      const words = this.commentText.split(/\s+/);
      const lastWord = words[words.length - 1].trim();
      if (lastWord === "@") {
        this.searchQuery = "";
        this.showSuggestions = this.group_members.length > 0;
        return;
      }

      if (lastWord.startsWith("@") && lastWord.length > 1) {
        this.searchQuery = lastWord.slice(1);
        this.showSuggestions = this.filteredUsers.length > 0;
      } else {
        this.showSuggestions = false;
        this.searchQuery = "";
      }
    },

    handleScroll() {
      const container = this.$refs.scrollContainer;
      if (!container) return;

      const scrollBottom = container.scrollTop + container.clientHeight;
      if (scrollBottom >= container.scrollHeight - 50) { // near bottom
        this.fetchGroupFeeds();
      }
    },

    handle_unauthenticated() {
      if (!this.token_exists) {
        this.$router.push({ name: 'sign_in_finale', },
        );
        return false;
      }
      return true;
    },

    getToken() {
      return get_token();
    },

    get_user_id() {
      const user_id = localStorage.getItem('user_id') || '';
      return user_id;
    },

    getFileIcon(fileUrl) {
      const iconMap = [
        { extensions: ['.pdf'], icon: 'https://cdn-icons-png.flaticon.com/128/337/337946.png' },
        { extensions: ['.doc', '.docx'], icon: 'https://cdn-icons-png.flaticon.com/128/337/337932.png' },
        { extensions: ['.xls', '.xlsx', '.csv'], icon: 'https://cdn-icons-png.flaticon.com/128/337/337958.png' },
        { extensions: ['.ppt', '.pptx'], icon: 'https://cdn-icons-png.flaticon.com/128/337/337950.png' },
        { extensions: ['.html', '.htm'], icon: 'https://cdn-icons-png.flaticon.com/128/732/732212.png' },
      ];

      for (const { extensions, icon } of iconMap) {
        if (extensions.some(ext => fileUrl.includes(ext))) {
          return icon;
        }
      }

      return 'https://cdn-icons-png.flaticon.com/128/337/337940.png'; // Default file icon
    },
    getFileName(fileUrl) {
      const decodedUrl = decodeURIComponent(fileUrl);
      const cleanUrl = decodedUrl.split('?')[0];
      return cleanUrl.substring(cleanUrl.lastIndexOf('/') + 1);
    },

    resetSelection() {
      this.editFileName = '';
      this.edit_feed_name = '';
      this.edit_feed_description = '';
      this.edit_files = [];
      this.edit_feed_id = null;
      this.group_can_comment = true,
        this.upload_media = '';
      this.audio_file = null;
    },

    handleEditFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        if (file.type.startsWith('audio/')) {
          this.editFileError = 'Audio files are not allowed.';
          this.upload_media = null;
          this.editFileName = '';
          event.target.value = '';
        } else {
          this.editFileName = file.name;
          this.editFileError = '';
          this.upload_media = file;
        }
      } else {
        this.editFileName = '';
        this.editFileError = '';
        this.upload_media = null;
      }
    },

    handleEditAudioUpload(event) {
      const file = event.target.files[0];
      if (file) {
        if (!file.type.startsWith('audio/')) {
          this.editAudioError = 'Only audio files are allowed.';
          this.audio_file = null;
          this.audio_file_name = '';
          event.target.value = '';
        } else {
          this.audio_file_name = file.name;
          this.editAudioError = '';
          this.audio_file = file;
        }
      } else {
        this.audio_file_name = '';
        this.editAudioError = '';
        this.audio_file = null;
      }
    },

    startRecording() {
      navigator.mediaDevices.getUserMedia({ audio: true })
        .then((stream) => {
          this.mediaRecorder = new MediaRecorder(stream);

          this.mediaRecorder.ondataavailable = (event) => {
            if (event.data.size > 0) {
              this.recordedChunks.push(event.data);
            }
          };

          this.mediaRecorder.onstop = () => {
            const audioBlob = new Blob(this.recordedChunks, { type: 'audio/wav' });
            this.audio_file = audioBlob;
            this.audio_file_name = 'recording.wav';
          };

          this.mediaRecorder.start();
          this.isRecording = true;
        })
        .catch((error) => {
          if (error.name === 'NotAllowedError') {
            Swal.fire({
              icon: 'error',
              title: 'Microphone Access Denied',
              text: 'Please allow microphone access in your browser settings and refresh the page.',
              position: 'bottom-end',
              showConfirmButton: false,
              timer: 3000,
              toast: true
            });
          } else {
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: `Error accessing microphone: ${error.message}`,
              position: 'bottom-end',
              showConfirmButton: false,
              timer: 3000,
              toast: true
            });
          }
        });
    },

    stopRecording() {
      if (this.mediaRecorder && this.isRecording) {
        this.mediaRecorder.stop();
        this.isRecording = false;
      }
    },

    fetchGroupMembers() {
      this.isLoading = true;
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/group_management/get_group_member/`,
        method: 'GET',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },

        data: { group_id: this.$route.params.group_id },
        success: (response) => {
          this.group_members = response.members.filter(member => !member.has_exited);
          this.group_creator_id = response.created_by;
          this.user_id = this.get_user_id();
          this.isCreator = Number(this.user_id) === Number(this.group_creator_id);
        },
        error: () => {
          this.group_members = [];
        },
        complete: () => {
          this.isLoading = false;
          this.fetchPortalMembers();
        },
      });
    },
    showDeleteMode() {
      this.deleteMode = true;
      this.exitMode = false;
    },

    display_comment_modal(feed_data) {
      if (!this.handle_unauthenticated()) {
        return;
      }

      this.feed_data = feed_data;
      this.comment_modal_visible = true;
    },

    add_new_group_feed(feed) {
      if (feed) {
        this.group_feeds.unshift(feed);
      }
    },

    showExitMode() {
      Swal.fire({
        title: 'Exit Group',
        text: "You are about to exit a group.Are you sure?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, exit',
        position: 'bottom-end',
        toast: true
      }).then((result) => {
        if (result.isConfirmed) {
          this.memberExitGroup();
        }
      });
    },

    fetchReportPreview(report) {
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/fetch_url_meta/`,
        type: 'POST',
        data: { url: report.report_link },
        headers: { Authorization: `Token ${this.getToken()}` },
        success: (data) => { report.linkPreview = data; },
      });
    },

    processGroupFeeds(results) {
      const map = new Map(
        this.group_feeds.map(r => [r.id, r])
      );
      results.forEach(report => {
        if (report.report_link) {
          this.fetchReportPreview(report);
        }
        map.set(report.id, report);
      });

      this.group_feeds = Array.from(map.values());
    },

    async fetchGroupFeeds() {

      if (this.is_feed_loading) return;
      this.is_feed_loading = true;
      const group_id = Number(this.$route.params.group_id);
      if (this.active_group_id !== group_id) {
        this.group_feeds = [];
        this.page = 1;
        this.hasMore = false;
        this.preloadedReports = [];
        this.active_group_id = group_id;
      }
      const report_id = Number(this.$route.query.report_id);
      const headersConfig = {
        headers: {
          Authorization: `Token ${this.getToken()}`,
          'Content-Type': 'application/json',
        },
      };

      try {
        let results = [];
        if (this.preloadedReports.length) {
          results = this.preloadedReports;
          this.preloadedReports = [];
          this.page += 1;
        } else {
          const response = await axios.post(
            `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_group_feed/`,
            { group_id, page: this.page, page_size: this.page_size },
            headersConfig
          );

          if (response.data.status === 'success' && response.data.group_data) {
            results = response.data.group_data.results || [];

            this.hasMore = response.data.group_data.has_more;
            this.page = response.data.group_data.page + 1;
          }
          else {
            results = [];
            this.hasMore = false;
          }
        }


        if (results.length) this.processGroupFeeds(results);

        if (this.hasMore) this.preloadedGroupFeeds(group_id);

        if (report_id) {
          const selectedReport = this.group_feeds.find(
            report => report.id === report_id
          );
          if (selectedReport) {
            this.display_comment_modal(selectedReport);
          }
        }
      } finally {
        this.is_feed_loading = false;
      }
    },

    async preloadedGroupFeeds(group_id) {
      const headersConfig = {
        headers: {
          Authorization: `Token ${this.getToken()}`,
          'Content-Type': 'application/json',
        },
      };

      try {
        const response = await axios.post(
          `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_group_feed/`,
          { group_id, page: this.page, page_size: this.page_size },
          headersConfig
        );
        if (response.data.status === 'success' && response.data.group_data) {
          this.preloadedReports = response.data.group_data.results || [];
          this.hasMore = response.data.group_data.has_more;
        }
      } catch (error) {
        console.error('Error fetching preloaded group feeds:', error.message);
        this.preloadedReports = [];
      }
    },

    getGroupMember(group_members) {
      return group_members.find(
        member => member.user.id === parseInt(this.user_id, 10)
      );
    },

    memberExitGroup() {
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/group_management/member_exit_group/`,
        method: 'DELETE',
        headers: {
          Authorization: `Token ${this.getToken()}`,
          'Content-Type': 'application/json',
        },
        data: JSON.stringify({
          group_id: this.$route.params.group_id,
        }),
        success: (response) => {
          Swal.fire({
            icon: 'success',
            title: 'Success',
            text: response.message,
            showConfirmButton: false,
            timer: 2000,
            position: 'bottom-end',
            toast: true
          }).then(() => {
            this.fetchGroupMembers();
          });
        },
        error: (xhr) => {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: xhr.responseJSON?.message || "Failed to exit group",
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 3000,
            toast: true
          });
        },
      });
    },

    removeSelectedMembers() {
        const count = this.selectedUserIds.length;

      if (count === 0) {
        Swal.fire({
          icon: 'warning',
          title: 'Warning',
          text: 'No members selected for removal.',
          position: 'bottom-end',
          showConfirmButton: false,
          timer: 3000,
          toast: true
        });
        return;
      }

       const text = count === 1
          ? 'You are about to remove a user from the group. Are you sure?'
          : `You are about to remove ${count} users from the group. Are you sure?`;


      Swal.fire({
        title: "Remove Members",
        text: text,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Continue',
        position: 'bottom-end',
        toast: true
      }).then((result) => {
        if (result.isConfirmed) {
          $.ajax({
            url: `${process.env.VUE_APP_BACKEND_API_URL}/group_management/remove_group_member/`,
            method: 'DELETE',
            headers: {
              Authorization: `Token ${this.getToken()}`,
              'Content-Type': 'application/json',
            },
            data: JSON.stringify({
              user_id: this.selectedUserIds,
              group_id: this.$route.params.group_id,
            }),
            success: (response) => {
              Swal.fire({
                icon: 'success',
                title: 'Success',
                text: response.message,
                showConfirmButton: false,
                timer: 2000,
                position: 'bottom-end',
                toast: true
              }).then(() => {
                this.group_members = this.group_members.filter(
                  item => !this.selectedUserIds.includes(item.user.id)
                );
                $("#delete_group_member_modal").modal("hide");
              });
            },
            error: (xhr) => {
              Swal.fire({
                icon: 'error',
                title: 'Error',
                text: xhr.responseJSON?.message || 'Failed to remove members.',
                position: 'bottom-end',
                showConfirmButton: false,
                timer: 3000,
                toast: true
              });
            },
          });
        }
      });
    },

    deleteGroupFeed(feed_id) {
      Swal.fire({
        title: 'Are you sure?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        position: 'bottom-end',
        toast: true
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            title: 'Deleting...',
            text: 'Please wait while we process your request.',
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            }
          });

          $.ajax({
            type: "DELETE",
            url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/delete_group_feed/`,
            data: JSON.stringify({ feed_id: feed_id }),
            headers: {
              'Authorization': `Token ${this.getToken()}`,
              'Content-Type': 'application/json'
            },
            success: (response) => {
              const status = response.status;
              if (status === "success") {
                Swal.fire({
                  title: 'Deleted!',
                  text: 'The group feed has been deleted.',
                  icon: 'success',
                  showConfirmButton: false,
                  timer: 1000,
                  position: 'bottom-end',
                  toast: true
                }).then(() => {
                  this.group_feeds = this.group_feeds.filter(feed => feed.id !== feed_id);
                });
              }
            }
          });
        }
      });
    },

    truncateDescription(description, maxLength = 25) {
      const words = description.split(/\s+/);
      if (words.length > maxLength) {
        return words.slice(0, maxLength).join(" ") + '...';
      }
      return description;
    },


    isFeedExpanded(feedId) {
      return this.expandedFeeds.includes(feedId);
    },

    shouldShowReadMore(post) {
      const description = post.description;
      const wordCount = description.split(/\s+/).length;

      return wordCount > 25;
    },
    
    toggleFeedReadMore(feedId) {
      const index = this.expandedFeeds.indexOf(feedId);
      if (index === -1) {
        this.expandedFeeds.push(feedId);
      } else {
        this.expandedFeeds.splice(index, 1);
      }
    },


    closeFeedMenu(feed_id) {
      const checkbox = document.getElementById('menu-open-' + feed_id);
      if (checkbox) {
        checkbox.checked = false;
      }
    },

    baseUrl(post, type) {
      const baseUrl = `${window.location.origin}${this.$route.path}`;
      if (type === 'voice') {
        return `${baseUrl}?voice_id=${post.id}`;
      } else if (type === 'feed') {
        return `${baseUrl}?feed_id=${post.id}`;
      }
      return baseUrl
    },
    getIdFromURL(param) {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get(param);
    },


    likeFeed(group_feed) {
      if (!this.token_exists) {
        this.$router.push('/sign_in_finale');
        return;
      }
      const groupFeedId = group_feed.id;

      $.ajax({
        type: "POST",
        url: `${process.env.VUE_APP_BACKEND_API_URL}/group_management/add_group_feed_like/`,
        contentType: "application/json",
        headers: {
          'Authorization': `Token ${this.getToken()}`,
        },
        data: JSON.stringify({ group_feed_id: groupFeedId }),
        success: (response) => {
          if (response.status === "success") {


            const liked_report = this.group_feeds.find(like => like.id === groupFeedId);
            if (liked_report) {
              liked_report.like_count++;
              liked_report.total_likes++;

              const currentUser = {
                user: {
                  id: this.user_details.user_id,
                  first_name: this.user_details.first_name,
                  last_name: this.user_details.last_name,
                  profile_picture: this.user_details.profile_picture || null,
                  is_blocked: false
                }
              };

              // Prevent duplicates
              const alreadyLiked = liked_report.likes.some(
                (u) => u.user && u.user.id === this.user_details.user_id
              );

              if (!alreadyLiked) {
                liked_report.likes.push(currentUser);
              }
              // ✅ Replace reports array for reactivity (if needed)
              this.group_feeds = [...this.group_feeds];

            }


            if (
              (typeof groupFeedId === 'number' && Number.isInteger(groupFeedId)) ||
              (typeof groupFeedId === 'string' && !isNaN(groupFeedId) && Number.isInteger(Number(groupFeedId)))
            ) {
              Reflect.set(this.likedReports, groupFeedId, true);
              localStorage.setItem("likedReports", JSON.stringify(this.likedReports));
            }
          }
        }
      });
    },

    like_report_auth(group_feed_id, group_feed) {

      if (!this.handle_unauthenticated()) {
        return;
      }
      this.likeFeed(group_feed)
      this.$router.push({ name: 'home', params: { group_feed_id: group_feed_id, group_feed: group_feed } });

    },

    unlikeFeed(group_feed) {
      if (!this.token_exists) {
        this.$router.push('/sign_in_finale');
        return;
      }
      const groupFeedId = group_feed.id;
      $.ajax({
        type: "POST",
        url: `${process.env.VUE_APP_BACKEND_API_URL}/group_management/add_group_feed_like/`,
        contentType: "application/json",
        headers: {
          'Authorization': `Token ${this.getToken()}`,
        },
        data: JSON.stringify({ group_feed_id: groupFeedId }),
        success: (response) => {
          if (response.status === "success") {

            const unliked_report = this.group_feeds.find(like => like.id === group_feed.id);
            if (unliked_report) {
              if (unliked_report.like_count > 0) {
                unliked_report.like_count--;   // update like count shown on each report
              }
              if (unliked_report.total_likes > 0) {
                unliked_report.total_likes--; // update global total likes
              }

              try {
                const currentUserId = String(this.user_details.user_id);
                if (Array.isArray(unliked_report.likes)) {
                  const idx = unliked_report.likes.findIndex(u => u && u.user && String(u.user.id) === currentUserId);
                  if (idx !== -1) {
                    unliked_report.likes.splice(idx, 1);
                  }
                }
                // Ensure modal list is synced if it was opened
                if (Array.isArray(this.modal_likes) && this.modal_likes.length) {
                  this.modal_likes = this.modal_likes.filter(u => !(u && u.user && String(u.user.id) === currentUserId));
                }
              } catch (err) {
                console.warn('Error removing user from likes:', err);
              }

              // Reassign reports to trigger reactivity
              this.group_feeds = [...this.group_feeds];
            }

            // Validate groupFeedId before setting
            if (
              (typeof groupFeedId === 'number' && Number.isInteger(groupFeedId)) ||
              (typeof groupFeedId === 'string' && /^[a-zA-Z0-9_-]+$/.test(groupFeedId))
            ) {
              Reflect.set(this.likedReports, groupFeedId, false);
              localStorage.setItem("likedReports", JSON.stringify(this.likedReports));
            } else {
              console.warn('Invalid groupFeedId:', groupFeedId);
            }


          }
        }
      });
    },

    getGroupFeedLikes(group_feed) {
      if (!group_feed || !group_feed.id) {
        return;
      }
      $.ajax({
        type: "GET",
        url: `${process.env.VUE_APP_BACKEND_API_URL}/group_management/retrieve_group_feed_likes/`,
        headers: {
          Authorization: `Token ${this.getToken()}`,
        },
        data: { group_feed_id: group_feed.id },
        success: (response) => {
          if (response.status === "success") {
            const likes = response.data;
            group_feed.like_count = likes.length;

            const userId = this.get_user_id();
            const isLiked = likes.some(like => like.user.id === parseInt(userId, 10));

            const likeButton = document.getElementById(`like-button${group_feed.id}`);
            const likedButton = document.getElementById(`liked-button${group_feed.id}`);

            if (likeButton) {
              likeButton.classList.toggle('d-none', isLiked);
            }

            if (likedButton) {
              likedButton.classList.toggle('d-none', !isLiked);
            }
          }
        },
      });
    },

    copyFeedLinkToClipboard(feed) {
      const link = this.baseUrl(feed, 'feed');
      navigator.clipboard.writeText(link).then(() => {
        this.showToast('Link copied to clipboard!');
      })
    },
    showToast(message) {
      document.querySelector('#copyToast .toast-body').textContent = message;

      $('#copyToast').fadeIn(300).addClass('show');
      setTimeout(function () {
        $('#copyToast').fadeOut(30).removeClass('show');
      }, 3000);
    },


    edit_feed(feed) {
      this.edit_feed_description = feed.description;
      this.group_feed_id = feed.id;
      this.edit_files = feed;
      this.group_can_comment = feed.can_comment
      this.$nextTick(() => {
        const quillEditor = this.$refs.quillEditFeedEditorRef.getQuill();
        if (quillEditor) {
          quillEditor.clipboard.dangerouslyPasteHTML(feed.description);
        }
      });
    },
    getCarouselImages(report) {
      if (!report || !report.group_feed_files) {
        return [];
      }
      return report.group_feed_files.filter((item) =>
        item.file.file_url.includes('.jpg') ||
        item.file.file_url.includes('.JPG') ||
        item.file.file_url.includes('.png') ||
        item.file.file_url.includes('.PNG') ||
        item.file.file_url.includes('.avif') ||
        item.file.file_url.includes('.AVIF') ||
        item.file.file_url.includes('.jpeg') ||
        item.file.file_url.includes('.JPEG') ||
        item.file.file_url.includes('.webp') ||
        item.file.file_url.includes('.WEBP')
      )
    },


    edit_groupFeed() {
      Swal.fire({
        title: 'Submitting...',
        text: 'Please wait while we process your request.',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });
      this.isSubmitting = true;
      const formData = new FormData();
      const plainText = this.$refs.quillEditFeedEditorRef.getText().trim();
      this.edit_feed_description = plainText;
      formData.append('description', this.edit_feed_description);
      formData.append('feed_id', Number(this.group_feed_id));
      formData.append('group_id', this.$route.params.group_id);
      formData.append('can_comment', this.group_can_comment);

      if (this.upload_media) {
        formData.append('file', this.upload_media);
      }
      if (this.audio_file) {
        formData.append('file', this.audio_file, this.audio_file_name);
      }
      $.ajax({
        type: 'POST',
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/update_group_feed/`,
        data: formData,
        processData: false,
        contentType: false,
        headers: {
          'Authorization': `Token ${this.getToken()}`,
        },
        success: (response) => {

          if (response.status === 'success') {
            const updatedGroupFeed = response.group_feed;

            const feedIndex = this.group_feeds.findIndex(
              (feed) => feed.id === updatedGroupFeed.id
            );
            if (feedIndex !== -1) {
              this.group_feeds.splice(feedIndex, 1, updatedGroupFeed);
            }

            Swal.fire({
              icon: 'success',
              title: response.message,
              showConfirmButton: false,
              timer: 1000,
              position: 'bottom-end',
              toast: true
            }).then(() => {
              $('#edit_feed_modal').modal('hide');
              this.resetSelection();
            });
          }
        },
        error: (response) => {
          Swal.close()
          const response_data = response.responseJSON;
          this.errors.edit_feed_name = response_data.message
        },
        complete: () => {
          this.isSubmitting = false;
        }
      });
    },

    fetchPortalMembers() {
      let portal_id = this.$route.params.portal_id;
      if (!portal_id) return;

      this.is_loading = true;

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_portal_members/`,
        method: "GET",
        data: { portal_id: portal_id },
        headers: {
          Authorization: `Token ${this.getToken()}`,
          "Content-Type": "application/json",
        },
        success: (response) => {
          if (response.status === "success") {
            const groupUsers = this.group_members.map((gm) => gm.user);
            this.members = (response.data.members || [])
              .filter((member) => member.user)
              .filter(
                (member) =>
                  !groupUsers.some((user) => user.id === member.user.id)
              )
              .map((member) => member.user);
          }
        },
        error: (xhr) => {
          console.error("Error fetching portal members:", xhr);
        },
      });
    },
    addGroupMembers() {
      if (this.selectedUserIds.length === 0) {
        Swal.fire({
          icon: "warning",
          title: "Warning",
          text: "Please select at least one  user.",
          showConfirmButton: true,
        });
        return;
      }
      this.isSubmitting = true;
      const requestData = {
        group_id: this.$route.params.group_id,
        user_id: this.selectedUserIds,
      };
      $.ajax({
        method: "POST",
        url: `${process.env.VUE_APP_BACKEND_API_URL}/group_management/add_group_member/`,
        contentType: "application/json",
        headers: {
          Authorization: `Token ${this.getToken()}`,
          "Content-Type": "application/json",
        },
        data: JSON.stringify(requestData),
        success: (response) => {
          const status = response.status;
          if (status === "success") {
            Swal.fire({
              icon: "success",
              title: "Members Added Successfully",
              showConfirmButton: false,
              timer: 1000,
              position: 'bottom-end',
              toast: true
            }).then(() => {
              response.group.forEach((item) => this.group_members.push(item))
              this.selectedUserIds = [];
              $("#add_group_member_modal").modal("hide");
              this.searchQuery = "";
              this.members = (response.group || [])
                .filter((member) => member.user)
                .filter(
                  (member) =>
                    !this.group_members.some(
                      (user) => user.id === member.user.id
                    )
                )
                .map((member) => member.user);
            });
          }
        },
        complete: () => {
          this.isSubmitting = false;
        },
      });
    },

    resetAddGroupMemberModal() {
      this.selectedUserIds = [];
      this.searchQuery = "";
      this.members = [];
    },
    toggleSelectAll() {
      const filteredIds = this.members.map(user => user.id);
      if (this.areAllSelected) {

        this.selectedUserIds = this.selectedUserIds.filter(id => !filteredIds.includes(id));
      } else {
        this.selectedUserIds = [...new Set([...this.selectedUserIds, ...filteredIds])];
      }
    },
    toggleSelectForDeleteAll() {
      const filteredIds = (this.group_members.filter(item => item.user.role.role !== 'admin')).map(user => user.user.id);
      if (this.areAllForDeleteSelected) {
        this.selectedUserIds = this.selectedUserIds.filter(id => !filteredIds.includes(id));
      } else {
        this.selectedUserIds = [...new Set([...this.selectedUserIds, ...filteredIds])];
      }
    },
  },
};
